import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  getAuth,
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
} from "firebase/auth";
import { useDispatch } from "react-redux";
import { createUserApiCall } from "../../store/actions/projectAction";
import { Link, useNavigate } from "react-router-dom";
import { ROTUES } from "../../utils/global";

const OtpEnterScreen = ({ onOtpVarifyCallback }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Store OTP values in an array

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle OTP input change
  const handleChange = (e, index) => {
    const value = e.target.value;

    // Allow only numbers and handle pasting
    if (/[^0-9]/.test(value) && value !== "") return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next field automatically if the current input is filled
    if (value !== "" && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // Handle backspace
  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  // Form submission logic
  const onSubmit = async (data) => {
    onOtpVarifyCallback(otp, data);
  };

  useEffect(() => {
    const firstInput = document.getElementById("otp-input-0");
    if (firstInput) firstInput.focus();
  }, []);

  return (
    <div className="flex justify-center items-center ">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className=" p-6 rounded-lg w-full max-w-md"
      >
        <h2 className="text-2xl font-semibold text-center mb-4">Enter OTP</h2>
        <div className="flex justify-between space-x-2 mb-4">
          {otp.map((value, index) => (
            <Controller
              key={index}
              control={control}
              name={`otp[${index}]`}
              render={({ field }) => (
                <input
                  {...field}
                  id={`otp-input-${index}`}
                  type="text"
                  value={value}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleBackspace(e, index)}
                  maxLength={1}
                  className="w-12 h-12 text-center text-xl font-semibold border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              )}
            />
          ))}
        </div>
        {errors.otp && (
          <p className="text-red-500 text-center">{errors.otp?.message}</p>
        )}
        <div className="flex justify-end">
          <Link
            className="cursor-pointer"
            onClick={() => {
              window.location.href = ROTUES.register;
            }}
          >
            Create Account
          </Link>
        </div>

        {/* <div id="recaptcha-container-test"></div> */}
        <button
          type="submit"
          className="w-full mt-4 bg-[#00428C]  text-white py-2 px-4 rounded-lg"
        >
          Verify OTP
        </button>
      </form>
    </div>
  );
};

export default OtpEnterScreen;
